import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';
import { PauseIcon, PlayIcon } from './icons';

@Component({
  tag: 'presto-playlist-item',
  styleUrl: 'presto-playlist-item.scss',
  shadow: true,
})
export class PrestoPlaylistItem {
  /** Active status */
  @Prop() active: boolean = false;

  /** Playing status */
  @Prop() playing: boolean = false;

  /** Emit play event */
  @Event() triggerPlay: EventEmitter<void>;

  /** Emit pause event */
  @Event() triggerPause: EventEmitter<void>;

  /**
   * Rendering the component
   */
  render() {
    return (
      <div
        class={{
          'playlist__item': true,
          'playlist__item-is--active': this.active,
          'playlist__item-is--playing': this.playing,
        }}
        onClick={() => {
          this.playing ? this.triggerPause.emit() : this.triggerPlay.emit();
        }}
      >
        <div class="playlist__title-wrap">
          <div class="playlist__play-icon">{this.playing ? <PauseIcon /> : <PlayIcon />}</div>
          <slot name="item-title" />
        </div>
        <div class="playlist__time">
          <slot name="item-duration" />
        </div>
      </div>
    );
  }
}
